// React
import React from 'react';
import { createRoot } from 'react-dom/client';

// Store
import { Provider } from 'react-redux';
import { store } from './data/store';

// Components JS
import QuoteTool from './quote-tool';

// Components CSS
import './index.css';

// Constants
const CONTAINER = document.getElementById('root');
const ROOT = createRoot(CONTAINER);
const SCRIPT = document.createElement('script');
const API_KEY = 'AIzaSyC9gQ8XeTNWjI4iYq1BxiGl4cxUZqKOqTo';

// Prepare Google API
SCRIPT.src = `https://maps.googleapis.com/maps/api/js?loading=async&key=${API_KEY}&libraries=places,geometry`;
SCRIPT.async = true;
document.body.appendChild(SCRIPT);

// Render
SCRIPT.onload = () => {
    return ROOT.render(
        <React.StrictMode>
            <Provider store={store}>
                <QuoteTool />
            </Provider>
        </React.StrictMode>
    );
};
